import { render, staticRenderFns } from "./EconomyCo2WidgetComponent.vue?vue&type=template&id=470d452b&"
import script from "./EconomyCo2WidgetComponent.vue?vue&type=script&lang=js&"
export * from "./EconomyCo2WidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./EconomyCo2WidgetComponent.vue?vue&type=style&index=0&id=470d452b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports